// „Tabellen" / Datasets (frontend/src/pages/Datasets.tsx) — deutsche QUELLE.
//
// `status` ersetzt die vorher seiten-lokale Map DATASET_STATUS_DE. Sie bleibt
// eine eigene Map (und wandert NICHT nach ui/labels.ts): für Datasets heisst
// `extracting` „Wird extrahiert", global dagegen „Extrahiert …" — der
// Domänen-Text gehört zur Domäne, die Badge-FARBE weiter zu labels.ts.
//
// Bewusst NICHT hier: der Vorgabe-Name „Schema-Vorschlag" eines per
// Schema-Inferenz angelegten Datasets. Der wird gespeichert (Datensatz-Name),
// ist also Inhalt und keine Beschriftung.
export const datasets = {
  // Liste
  neuesDataset: "Neues Dataset",
  dokumente: "Dokumente",
  web: "Web",
  zeilen: (n: number) => `${n} Zeilen`,
  keineTabellen: "Noch keine Tabellen",
  keineTabellenHinweis: "Erstelle deine erste Tabelle aus Dokumenten oder aus dem Web.",
  neueTabelle: "Neue Tabelle",

  // Zustände (seiten-eigene Fassung, s. Kopf). Bewusst OHNE
  // `as Record<string, string>`: nur mit den einzelnen Keys im Typ meldet tsc
  // einen in ../en/datasets.ts vergessenen Zustand. Die Stelle, die mit einem
  // rohen Status-String indiziert, castet dort (Muster: ui/labels.ts).
  status: {
    draft: "Entwurf",
    queued: "In Warteschlange",
    extracting: "Wird extrahiert",
    ready: "Bereit",
    error: "Fehler",
  },
  abdeckung: (prozent: number) => `Abdeckung ${prozent} %`,

  // Runner-Diagnose
  abschnitteUebersprungen: (n: number) =>
    `${n} Abschnitt${n === 1 ? "" : "e"} übersprungen`,
  enumWerteGeleert: (n: number) => `${n} Enum-Wert${n === 1 ? "" : "e"} geleert`,
  faktenNichtAbgedeckt: (n: number) => `${n} Fakt${n === 1 ? "" : "en"} nicht abgedeckt`,
  nachschlagAusgefuehrt: "Nachschlag ausgeführt",

  // Extraktions-Zustand
  inWarteschlange: "In Warteschlange — Extraktion startet gleich …",
  wirdExtrahiert: "Tabelle wird extrahiert …",
  extraktionHinweis:
    "Das Modell liest das Dokument und befüllt die Spalten — typisch 30–60s. Die Ansicht aktualisiert sich automatisch.",

  // Assistent
  name: "Name",
  quelle: "Quelle",
  dokumenteIngested: "Dokumente (ingested)",
  webDeepResearch: "Web (Deep-Research)",
  dokumenteAuswaehlen: "Dokumente auswählen",
  keineDokumenteHochgeladen: "Noch keine Dokumente hochgeladen.",
  seedUrls: "Seed URLs (eine pro Zeile, Komma erlaubt)",
  mussEnthalten: "Muss enthalten (Keyword)",
  mussEnthaltenPlatzhalter: "z.B. Frühstück",
  fakeHinweisVor: "Hinweis: DEEP_RESEARCH_FAKE muss auf ",
  fakeHinweisNach:
    " stehen und die Deep-Research-API muss erreichbar sein, sonst kommt nur Fake-Markdown.",
  spalten: "Spalten",
  schemaVorschlagen: "Schema vorschlagen",
  spalteHinzufuegen: "+ Spalte",
  spalteName: "Name",
  spalteTyp: "Typ",
  spalteBeschreibung: "Beschreibung",
  datasetAnlegen: "Dataset anlegen",
  erstDokumenteWaehlen: "Wähle erst Dokumente zur Schema-Inferenz.",

  // Detail
  laedt: "Lädt …",
  zurueckZurListe: "Zurueck zur Dataset-Liste",
  datasets: "Datasets",
  statusLabel: "Status:",
  csvTitel: "Sichtbare (gefilterte + sortierte) Rows als CSV herunterladen",
  csv: "CSV",
  run: "Run",
  laeuft: "läuft …",
  reparierenKlein: "reparieren",
  loeschenKlein: "löschen",
  datasetLoeschen: "Dataset löschen?",
  datasetReparieren: "Dataset reparieren?",
  reparierenBeschreibung:
    "Verwaiste Datasets (keine Quell-Docs mehr) werden gelöscht, leere neu aufgebaut, intakte bleiben unverändert.",
  reparieren: "Reparieren",
  ok: "OK",
  repairGeloescht: "Dataset war verwaist (keine Docs mehr) und wurde gelöscht.",
  repairNeuAufgebaut: "Dataset hatte 0 Zeilen — Neu-Aufbau angestoßen.",
  repairInOrdnung: (zeilen: number) => `Alles in Ordnung (${zeilen} Zeilen).`,

  tabTabelle: "Tabelle",
  tabChat: "Chat",
  erstRunAusfuehren: "Erst Run ausführen",
  extraktionFehlgeschlagen: "Extraktion fehlgeschlagen",
  unbekannterFehler: "Unbekannter Fehler — bitte Run erneut starten.",

  // Tabelle
  suchePlatzhalter: "Semantisch suchen in Dataset-Zeilen …",
  sucheAria: "Semantisch in Dataset-Zeilen suchen",
  // Die Zahlen kommen bereits deutsch formatiert herein (toLocaleString("de-DE"),
  // docs/i18n.md: Zahlformate bleiben deutsch) — deshalb Strings, keine Zahlen.
  limitErreicht: (zeilen: string, geladen: string) =>
    `Limit erreicht: Dataset hat ${zeilen} Zeilen, geladen sind nur ${geladen}. Sort + Filter operieren nur auf den geladenen Rows — server-seitiger Filter folgt noch.`,
  horizontalScrollen: "← Tabelle horizontal scrollen →",
  section: "Section",
  headingPfad: "Heading-Pfad",
  sortierungUmschalten: "Sortierung umschalten (asc → desc → aus)",
  filternPlatzhalter: "filtern …",
  spalteFiltern: (spalte: string) => `Spalte ${spalte} filtern`,
  statusRunStarten: (status: string) => `Status: ${status} — Run starten, um Zeilen zu erzeugen.`,
  keineZeilen: "Keine Zeilen — Run starten oder neu suchen.",
  filterOhneTreffer: "Filter ergaben keinen Treffer — Filter anpassen oder leeren.",
  dokument: "Dokument",
  quelleMitSeite: (bezeichnung: string, seite: string) => `${bezeichnung} · S.${seite}`,
};

export type DatasetsKatalog = typeof datasets;
